import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { RecalProposalSetEntity } from "domain/entity/RecalProposalSet/RecalProposalSetEntity";
import { TariffRecalProposalEntity } from "domain/entity/RecalProposalSet/TariffRecalProposalEntity";
import { axiosGetData, axiosPostData } from "../axios/AxiosBasicImpl";
import tariffAxiosInstance from "../axios/tariffAxiosInstance";
import { RecalProposalSetRepository } from "./RecalProposalSetRepo";

export const RecalProposalSetRepoImpl = (): RecalProposalSetRepository => {


    const searchAllRecalProposalSetList = async (): Promise<RecalProposalSetEntity[]> => {
        const searchUrl = "/v1/recalProposalSet"
        return axiosGetData(tariffAxiosInstance, `${searchUrl}`, []).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const searchRecalProposalSetCombox = async (): Promise<TariffRecalProposalEntity[]> => {
        const searchUrl = "/v1/recalProposalCombox"
        return axiosGetData(tariffAxiosInstance, `${searchUrl}`, []).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }

    const onSave = async (row: RecalProposalSetEntity): Promise<ResponseEntity> => {
        const saveUrl = "/v1/recalProposalSetSave"
        return await axiosPostData(tariffAxiosInstance, `${saveUrl}`, row);
    }

    const deleteEntity = async (rows: RecalProposalSetEntity[]): Promise<ResponseEntity> => {
        const deleteUrl = "/v1/recalProposalSetDelete"
        return await axiosPostData(tariffAxiosInstance, `${deleteUrl}`, rows);
    }

    return {
        onSave: onSave,
        searchAllRecalProposalSetList: searchAllRecalProposalSetList,
        searchRecalProposalSetCombox: searchRecalProposalSetCombox,
        deleteEntity: deleteEntity,
    }
}
